import { AuthGuard } from "@dis/auth";
import { JtmsRoutes, groupOverview } from "../core/routing/route-data";

export default [
  {
    path: "",
    canMatch: [AuthGuard],
    data: { navGroup: "billing" },
    children: [
      groupOverview(() => import("../feature/overviews/billing-overview").then((m) => m.BillingOverview)),
      {
        path: "invoices",
        data: { navOrder: 1 },
        loadComponent: () =>
          import("../feature/office/invoices/invoice-table/invoice-table").then((m) => m.InvoiceTable),
        title: "Invoices",
      },
      {
        path: "post-job-status",
        data: { navOrder: 2 },
        loadComponent: () =>
          import("../feature/shop/ship-n-receiving/update-post-job-status/update-post-job-status-container/update-post-job-status-container.component").then(
            (m) => m.UpdatePostJobStatusContainer
          ),
        title: "Post-Job Status",
      },
    ],
  },
] satisfies JtmsRoutes;
